exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.table-plan{\n  border-collapse: collapse;\n  width: 70%;\n}\n\n.table-holi{\n  border-collapse: collapse;\n  width: 30%;\n}\n\n.table-pac{\n  border-collapse: collapse;\n  width: 70%;\n}\n.table-call{\n  border-collapse: collapse;\n  width: 100%;\n  text-align: center\n}\n\n\ntable {\n  border-collapse: collapse;\n  width: 99%;\n  /*table-layout:fixed; */\n}\n\nth, td {\n/*text-align: left;*/\n  padding: 4px;\n  font-size: 14px;\n  font-family: Arial, Verdana, sans-serif;\n  column-gap: 0px;\n  word-wrap: break-word;\n  max-width: 250px;\n}\n\n.shorter{\n  width:50%;\n}\n\n.table_cell{\n  display:table-cell;\n  width:50px;\n}\n\n\n.myBtn {\n  display: inline-block;\n  font-weight: 250;\n  line-height: 1.25;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-size: 1rem;\n  border-radius: .25rem;\n  transition: all .2s ease-in-out;\n}\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/patients/patients.component.css
// module id = 567
// module chunks = 1